module.exports = __webpack_public_path__ + "img/walkthrough_illust24@2x.0ba804f4.png";